import { Spinner } from '@blueprintjs/core';

const LoadingOverlay = () => {
  return (
    <div className="txn-file-upload-overlay-zx9k">
      <div className="txn-file-upload-card-zx9k">
        <Spinner size={60} />
        <div className="txn-file-upload-title-zx9k">
          Cargando información...
        </div>
        <div className="txn-file-upload-subtitle-zx9k">
          Por favor espere mientras procesamos la información
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
